import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { fetchCoins } from './thunks';
import type { CoinsState } from './types';

const initialState: CoinsState = {
  coins: 0,
};

type CoinsPayload = number | string | undefined;

export const coinsSlice = createSlice({
  name: 'coins',
  initialState,
  reducers: {
    setCoins: (state, action: PayloadAction<CoinsPayload>) => {
      state.coins = Number(action.payload ?? 0);
    },
    addCoins: (state, action: PayloadAction<CoinsPayload>) => {
      state.coins = state.coins + Number(action.payload ?? 0);
    },
    reduceCoins: (state, action: PayloadAction<CoinsPayload>) => {
      state.coins = state.coins - Number(action.payload ?? 0);
    },
    clearCoins: (state) => {
      state.coins = 0;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchCoins.fulfilled, (state, action) => {
      state.coins = Number(action.payload ?? 0);
    });
  },
});

export const { reduceCoins, addCoins, clearCoins, setCoins } =
  coinsSlice.actions;
export const coinsReducer = coinsSlice.reducer;
